(function() {
  var COLLECTION_HANDLE = 'practi-dose';
  var MOQ_CENTS = 10000;

  function fetchAllCollectionIds(handle) {
    var url = '/collections/' + handle + '/products.json?limit=250&fields=id';
    return fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var ids = data.products.map(function(p) { return p.id; });
        if (data.products.length < 250) {
          return ids;
        }
        // Fetch page 2
        return fetch(url + '&page=2')
          .then(function(r) { return r.json(); })
          .then(function(data2) {
            return ids.concat(data2.products.map(function(p) { return p.id; }));
          });
      });
  }

  function checkMOQ() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items || cart.items.length === 0) {
          applyState(false, 0);
          return;
        }
        fetchAllCollectionIds(COLLECTION_HANDLE)
          .then(function(practiIds) {
            var practiTotal = 0;
            var hasPracti = false;
            cart.items.forEach(function(item) {
              if (practiIds.indexOf(item.product_id) !== -1) {
                practiTotal += item.final_line_price;
                hasPracti = true;
              }
            });
            applyState(hasPracti, practiTotal);
          })
          .catch(function() { applyState(false, 0); });
      })
      .catch(function() { applyState(false, 0); });
  }

  function applyState(hasPracti, practiTotal) {
    var warning = document.getElementById('practi-dose-moq-warning');
    var checkoutBtn = document.getElementById('checkout');
    var dynamicBtns = document.querySelector('.cart__dynamic-checkout-buttons');
    if (hasPracti && practiTotal < MOQ_CENTS) {
      if (warning) warning.style.display = 'block';
      if (checkoutBtn) { checkoutBtn.disabled = true; checkoutBtn.style.opacity = '0.5'; checkoutBtn.style.cursor = 'not-allowed'; }
      if (dynamicBtns) dynamicBtns.style.display = 'none';
    } else {
      if (warning) warning.style.display = 'none';
      if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.style.opacity = ''; checkoutBtn.style.cursor = ''; }
      if (dynamicBtns) dynamicBtns.style.display = '';
    }
  }

  document.addEventListener('DOMContentLoaded', checkMOQ);
  document.addEventListener('cart:updated', checkMOQ);
})();
